import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AssignSharedFolderComponent } from '../dialog/assign-shared-folder/assign-shared-folder.component';
import { CreateService } from '../services/create.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-access-request',
  templateUrl: './access-request.component.html',
  styleUrls: ['./access-request.component.scss']
})
export class AccessRequestComponent {

  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['driveId', 'driveName', 'licenseType', 'permType', 'role','userEmail', 'userName', 'edit', 'delete'];

  emailId: string = '';
  driveId: string = '';
  isError: boolean = false;
 
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor( private createService: CreateService,
     private toastr: ToastrService, private router: Router){

  }
  
  fetchUser() {
    this.createService.fetchUser(this.driveId, this.emailId).subscribe({
      next: (userData: any) => {
        if (userData ) {
       //   console.log(userData);
          this.dataSource.data = userData;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } 
      },
      error: (e: any) => {
        this.toastr.error("Error while fetching User data");
      }
    })
  }

  editUser(row: any){
    this.createService.setIsViewEdit(true);
    this.createService.setViewEditObj(row);
    this.router.navigate(['/add-user']);
  }

  addUser(){
    this.createService.setIsViewEdit(false);
    this.createService.setViewEditObj(null);
    this.router.navigate(['/add-user']);
  }

  deleteUser(row: any){
    console.log(row);
    this.createService.deleteUser(row).subscribe({
      next: (message: any)=>{

        if(message == "Deleted User Successfully"){
          this.toastr.success(message);
          this.fetchUser();
        }
        

      },
      error: (e: any)=>{
        this.toastr.error("Error while deleting User data");
      }
    })
  }
}
